import React from 'react'

import { Link } from 'react-router-dom'

import style from './Card.module.css'

import { Chart } from 'common/components'
import { Paths } from 'common/routes'
import { getCardImage } from 'common/utils'
import { CategoryDomain } from 'features/dashboard'

type PropsType = {
  category: CategoryDomain
}

export const Card = ({ category }: PropsType) => {
  const results = category.activities.results

  const minimalAttemptsTask = category.tasks.reduce((acc, curr) => {
    return curr.activities.attempts < acc.activities.attempts ? curr : acc
  })

  const nextTaskPath = `${Paths.Simulator}${minimalAttemptsTask.id}`

  return (
    <li className={`box ${style.box}`}>
      <div className={style['text-column']}>
        <Link className={style['title-link']} to={nextTaskPath} title="Начать тренировку">
          <h3 className={style.title}>{category.title}</h3>
        </Link>

        <div>
          {results.length !== 0 && (
            <p
              className={style.property}
              title="Количество символов в минуту на последней тренировке"
            >
              Оценка: {results.at(-1)}
            </p>
          )}
          <p className={style.property}>Тренировок: {category.activities.attempts}</p>
        </div>
      </div>

      <div className={style['chart-box']}>
        <Link to={nextTaskPath} className={style['chart-image-link']} title="Начать тренировку">
          <img src={getCardImage(category.title)} alt={category.title} width="45" height="45" />
        </Link>
        {results.length > 0 && <Chart data={results} className={style.chart} />}
      </div>
    </li>
  )
}
